module.exports = __webpack_public_path__ + "static/img/logo.3e2e3ffe.png";